import { render, staticRenderFns } from "./room-door.vue?vue&type=template&id=404c97cb&scoped=true"
import script from "./room-door.vue?vue&type=script&lang=js"
export * from "./room-door.vue?vue&type=script&lang=js"
import style0 from "./room-door.vue?vue&type=style&index=0&id=404c97cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c97cb",
  null
  
)

export default component.exports